export enum ApplicationRejectionReason {
  INVALID_LOCATION = 'INVALID_LOCATION',
  INVALID_DOCUMENTS = 'INVALID_DOCUMENTS',
}
